module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a1",
    attrs: {
      "id": "ack1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/contents#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center1-o"
  }, [_c('span', [_vm._v("My thanks to Dr. Marjory Foyle and Dr. Debbie Lovell-Hawker"), _c('br'), _vm._v("\n  for their input and encouragement.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee5018e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgements.vue
// module id = 69
// module chunks = 0